import { Select } from 'antd';
import useAuth from 'common/useAuth';
import { saveLanguageCode, useCustomTranslation } from 'helpers/translationHelper';
import type { SUPPORTED_LANGUAGES_TYPE } from 'i18n';
import { SUPPORTED_LANGUAGES } from 'i18n';
import React from 'react';

const LanguageSwitcher: React.FC = (): React.ReactElement => {
  const { tCommon, i18n } = useCustomTranslation();

  const { setLanguage } = useAuth();

  return (
    <Select
      value={i18n.language as SUPPORTED_LANGUAGES_TYPE}
      options={SUPPORTED_LANGUAGES.map((lng) => ({ value: lng, label: tCommon(lng) }))}
      onChange={(lng) => {
        saveLanguageCode(lng);
        setLanguage(lng);
      }}
    />
  );
};

export default LanguageSwitcher;
